<template>
  <div class="content-right" :style="{ height:`${!isForget ? 500 : 380 }px` }">
    <div class="title" :class="{ forgetTitle: isForget }">{{ `${isForget ? '忘记密码' : '小智欢迎您'}` }}</div>
    <div v-show="!isForget" class="loginTypes" :class="{ mb20: loginType === 'wxCode' }">
      <div class="loginType" :class="{ active: loginType === 'account' }" @click="typeClick('account')">
        账号登录
      </div>
      <div class="loginType" :class="{ active: loginType === 'wxCode' }" @click="typeClick('wxCode')">
        扫码登录
      </div>
    </div>

    <!-- 微信扫码登录 -->
    <div class="wx_reg" id="wx_reg" v-if="loginType === 'wxCode'"></div>

    <!-- 账号登录 -->
    <el-form :model="form" :rules="rules" ref="ruleForm" v-else>
      <el-form-item prop="mobile">
        <div v-show="loginType === 'account'" class="inputs" >
          <img src="@/assets/img/phone.png" alt />
          <input type="text" v-model="form.mobile" class="mobile" placeholder="请输入手机号码" maxlength="11"/>
        </div>
      </el-form-item>
    
      <el-form-item :prop="isAccountLogin ? 'password' : ''" v-if="isAccountLogin" key="password">
        <div class="inputs">
          <img src="@/assets/img/password.png" alt style="width: 17.9px"/>
          <input name="password" type="password" v-model="form.password" class="mobile" placeholder="请输入密码"/>
        </div>
      </el-form-item>

      <el-form-item :prop="isShowForget ? 'captchaInfo' : ''" v-if="isShowForget && captchaSrc" key="captchaInfo">
        <div class="inputs">
          <img src="@/assets/img/sms.png" alt style="width: 18.9px" />
          <input type="text" v-model="form.captchaInfo" class="sms" placeholder="请输入图片验证码" maxlength="10"/>
            <img
              v-if="captchaSrc"
              :src="captchaSrc"
              @click="getCaptcha"
              class="login-code-img"
            />
            <img
              v-else
              alt="captcha"
              class="login-code-img"
              @click="getCaptcha"
            />
          </div>
      </el-form-item>      
    
      <el-form-item :prop="isShowForget ? 'smsCode' : ''" v-if="isShowForget" key="smsCode">
        <div class="inputs">
          <img src="@/assets/img/sms.png" alt style="width: 18.9px" />
          <input type="text" v-model="form.smsCode" class="sms" placeholder="请输入验证码" maxlength="10"/>
          <div class="send" @click="sendSms" v-if="isSend">
            发送验证码
          </div>
          <div class="send" v-else>{{ time }}s后重新发送</div>
          <div v-show="!isSend" class="time-tips">验证码有效期为5分钟，请尽快完成验证。</div>
        </div>
      </el-form-item>    
    </el-form>

    <div class="login" v-show="isAccountLogin">
      <el-button @click="validForm" :loading="loginLoading" :disabled="loginLoading">登录</el-button>
    </div>
    <div v-show="isAccountLogin" class="forget" @click="resetData(true)">
      忘记密码？
    </div>
    <div class="action" v-show="isForget">
      <div class="cancel" @click="resetData(false)">返回</div>
      <div class="next" @click="confirm">确定</div>
    </div>

    <!-- 短信安全验证 -->
    <el-dialog
      title="短信安全验证"
      :visible.sync="sendSmsCodeVisible"
      width="500px"
      custom-class="code-dialog"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      top="30vh"
      :before-close="handleClose">
      <div class="smsCode-wrap">
        <div class="smsCode-title">{{ `为保障企业信息安全，请输入发送至 “${form.mobile}” 的验证码` }}</div>

        <div class="inputs">
          <img src="@/assets/img/sms.png" alt style="width: 18.9px" />
          <input
            type="text"
            v-model="form.captchaInfo"
            class="sms"
            placeholder="请输入图片验证码"
            maxlength="10"
          />
          <div class="send">
            <img
              v-if="captchaSrc"
              :src="captchaSrc"
              @click="getCaptcha"
              class="login-code-img"
            />
            <img
              v-else
              alt="captcha"
              class="login-code-img"
              @click="getCaptcha"
            />
          </div>
        </div>

        <div class="inputs">
          <img src="@/assets/img/sms.png" alt style="width: 18.9px" />
          <input
            type="text"
            v-model="form.smsCode"
            class="sms"
            placeholder="请输入验证码"
            maxlength="10"
          />
          <div class="send" @click="sendSms" v-show="isSend">
            发送验证码
          </div>
          <div class="send" v-show="!isSend">{{ time }}s后重新发送</div>
          <div v-show="!isSend" class="time-tips">验证码有效期为5分钟，请尽快完成验证。</div>
        </div>
      </div>
      <span slot="footer">
        <el-button class="code-btn" type="primary" :loading="loginLoading" :disabled="loginLoading" @click.native.prevent="validCodeForm">登录</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import Cookies from "js-cookie";
import { decryptData, getMD5String } from "@/assets/js/crypto.js";
import { getExplore } from '@/assets/js/util'
// const passwordReg = /(?=.*\d)(?=.*[A-z])^[0-9A-z]{8,}$/;
import { goCas, dealerNetMap } from '@/assets/js/constant'
import { mapActions, mapGetters } from 'vuex'
import { deviceTypeMap } from "@/assets/js/commonMap.js";
const mobileReg = /^1[3-9]\d{9}$/;
const explore = getExplore()

export default {
  name: "ContentRight",
  data() {
    const validMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else if(!mobileReg.test(value)) {
        callback(new Error('请输入合法手机号码'));
      } else {
        callback();
      }
    };
    return {
      form: {
        mobile: "",
        smsCode: "",
        password: '',
        deviceType: '',
        deviceVersion: '', // 操作系统版本 window11
        device: `${explore.name} ${explore.fullVersion}`, // 浏览器类型
        deviceId: localStorage.getItem("deviceId"), // 设备id
        captchaId: '', // 图片验证码id
        captchaInfo: '', // 验证码信息
      },
      loginLoading: false,
      isForget: false,
      isSend: true,
      time: 60,
      loginType: 'account',
      qiweiInfo: {},
      sendSmsCodeVisible: false,
      rules: {
        mobile: [
          { required: true, validator: validMobile, trigger: 'blur' }
        ],
        password:[
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        captchaInfo: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      captchaSrc: '',
    };
  },
  computed: {
    ...mapGetters('common', ['osInfo']),
    isAccountLogin() {
        return !this.isForget && this.loginType === 'account'
    },
    isShowForget() {
       return this.isForget && this.loginType === 'account'
    }
  },
  methods: {
    ...mapActions('common', ['getDealerCodeGray', 'getModernOSInfo']),
    handleClose() {
      this.sendSmsCodeVisible = false
    },
    resetData(isForget) {
      this.isForget = isForget;
      isForget && this.getCaptcha();
      this.form.mobile = "";
      this.form.smsCode = "";
      this.form.captchaId = ''
      this.form.captchaInfo = ''
      this.isSend = true;
      this.time = 60;
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.changePassword()
        } else {
          const isValid = this.validInfo({ mobile: true, smsCode: true })
          if (!isValid) return
        }
      });
    },
    changePassword() {
      const { mobile, smsCode } = this.form;
      this.$httpAuth
        .post("/v2/appUserService/changePassword", {
          mobile,
          smsCode,
        })
        .then(res=> {
          if (res.data.success) {
            this.$message({
              message: "新密码已以短信发送给您，请注意查收",
              type: "success"
            });
            this.resetData(false);
          }
        })
    },
    typeClick(type) {
      this.loginType = type;
      if (type === 'wxCode') {
        this.$nextTick(() => {
          const { qwCorpId, qwAgentId } = this.qiweiInfo;
            const wwLogin = new WwLogin({
      	  	"id": "wx_reg",  
      	  	"appid": qwCorpId,
      	  	"agentid": qwAgentId,
      	  	"redirect_uri": process.env.VUE_APP_SCAN_REDIRECT_URL,
      	  	"href": "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIxNnB4O30=",
          });
          // window.WwLogin({
          //   id: "wx_reg",
          //   appid: qwCorpId,
          //   agentid: qwAgentId,
          //   href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIxNnB4O30=",
          //   redirect_uri: process.env.VUE_APP_SCAN_REDIRECT_URL
          //   // redirect_uri: 'https://zz-dealerqa.bydauto.com.cn',// 测试
          //   // redirect_uri: 'https://zz-dealer.bydauto.com.cn',// 生产
          // });
        });
      }
    },
    // 发送验证码
    sendSms() {
      const isValid = this.validInfo({ mobile: true })
      if (!isValid) return
      if (this.isSend) {
        this.$httpAuth
          .post("/v2/appUserService/getSmsCode", {
            mobile: this.form.mobile,
            captchaId: this.form.captchaId,
            captchaInfo: this.form.captchaInfo
          })
          .then((res) => {
            if(res.data.success) {
              this.$message({
                message: '验证码已发送，如未收到验证码则请检查手机号是否正确',
                type: 'success'
              });
              this.isSend = false;
              this.phoneTimer();
            }
          }).finally(() => {
            
          })
      }
    },
    validInfo({ mobile = false, smsCode = false, password = false }) {
      if (mobile && !mobileReg.test(this.form.mobile)) {
        this.$message({
          message: `请输入${this.form.mobile?'合法':''}手机号码`,
          type: 'error'
        });
        return false
      }
      if (password && !this.form.password) {
        this.$message({
          message: '请输入密码',
          type: 'error'
        });
        return false
      }
      if (smsCode && !this.form.smsCode) {
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return
      }
      return true
    },
    validForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 没有deviceId直接弹窗验证码
          if(!this.form.deviceId) {
            this.sendSmsCodeVisible = true
            this.getCaptcha();
          } else {
            this.handleLogin()
          }
        } else {
          const isValid = this.validInfo({ mobile: true, password: true })
          if (!isValid) return
        }
      });
    },
    validCodeForm() {
      const isValid = this.validInfo({ password: true })
      if (!isValid) return
      this.handleLogin(true)
    },
    handleLogin(withCode = false) {
      if (this.loginLoading) return
      this.loginLoading = true;
      const params = this.getParams(withCode)
      const URL = withCode ? "/v2/appUserService/loginWithSmsCode" : "/v2/appUserService/loginWithoutSmsCode"
      this.$httpAuth
        .post(URL, params)
        .then(async res => {
          const { token = '', refreshToken = '', profile = {}, isAdmin = '', deviceId = '', needVerify } = res?.data ?? {}
          // 校验是否需要验证码登录
          if(needVerify && !withCode) {
            this.sendSmsCodeVisible = true
            this.getCaptcha();
            this.loginLoading = false;
            return
          }

          // this.$common.setDealer(profile);
          // Cookies.set("Dealer-User-Token", token);
          // this.$common.setAdmin(isAdmin);
          // this.$common.setLoginInfo(res.data);
          // if(deviceId) localStorage.setItem("deviceId", deviceId)
          // this.getConfigInfo()

          // 获取门店code 判断是否灰度 灰度跳转cas登录
          this.$common.setDealer(profile);
          const { dealerCode, type } = profile
          const grayres = await this.getDealerCodeGray({dealerCode, dealerNet: dealerNetMap.get(type) })
          if(grayres?.data?.status === 1 && grayres?.data?.data) {
            goCas()
          } else {
            Cookies.set("Dealer-User-Token", token);
            Cookies.set("Dealer-User-RefreshToken", refreshToken);
            this.$common.setAdmin(isAdmin);
            this.$common.setLoginInfo(res.data);
            if(deviceId) localStorage.setItem("deviceId", deviceId)
            this.getConfigInfo()
          }
        })
        .catch((e) => {
          this.loginLoading = false;
        });
    },
    getConfigInfo() {
      this.$httpAuth
        .post("/v2/appBaseService/info", { token: process.env.VUE_APP_INFO_TOKEN })
        .then(res => {
          this.loginLoading = false;
          this.$common.setBaseInfo(res.data);
          this.$router.push({
            path: "/dashboard/index"
          });
        }).catch(() => {
          this.loginLoading = false;
        });
    },
    getParams(withCode) {
      const { mobile, password, device, deviceVersion, deviceType, deviceId, smsCode } = this.form
      let value = {
        mobile,
        password: getMD5String(password),
        device,
        deviceType: deviceTypeMap.get(deviceType) ?? 0, // deviceType：0 pc windows, 1 ANDROID 2: ios 3.小程序 4. 鸿蒙 5 pc mac
        deviceVersion,
        deviceId,
      }
      if (withCode) value.smsCode = smsCode
      return value
    },
    // 手机倒计时
    phoneTimer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(() => {
          this.phoneTimer();
        }, 1000);
      } else {
        this.isSend = true;
        this.time = 60;
      }
    },
    getBase() {
      this.$httpAuth.post("/v2/appBaseService/info", { token: process.env.VUE_APP_INFO_TOKEN }).then((res) => {
        const { iv, ...rest } = res.data.qiweiInfo;
        this.qiweiInfo = decryptData(rest,iv)
      });
    },
    // 回车登录
    keyDownSubmit(e) {
      if (e.keyCode !== 13) {
        return
      }
      if (this.sendSmsCodeVisible) {
        this.validCodeForm()
      } else {
        this.validForm()
      }
    },
    getCaptcha() {
      this.form.captchaInfo = ''
      this.$httpAuth.post("/v2/appBaseService/refreshCaptcha", { token: process.env.VUE_APP_CAPTCHA_TOKEN }).then((res) => {
        const data = res.data;
        const { b64s = '', id = '' } = data;
        this.form.captchaId = id;
        this.captchaSrc = b64s;
      });
    }
  },
  created() {
    Cookies.set("Dealer-User-Token", "");
    Cookies.set("Dealer-User-RefreshToken", "");
    this.getBase();
    const dealer = this.$common.getDealer() || {}
    const { dealerCode, type } = dealer
    if(dealerCode) {
      this.getDealerCodeGray({ dealerCode, dealerNet: dealerNetMap.get(type) })
        .then(grayres=> {
          if(grayres?.data?.status === 1 && grayres?.data?.data) {
            this.$common.removeDealer()
            goCas()
          }
        })
    }
  },
  async mounted() {
    await this.getModernOSInfo()
    const { name, versionName } = this.osInfo
    this.form.deviceVersion = versionName
    this.form.deviceType = name
    // 绑定监听事件
    window.addEventListener("keydown", this.keyDownSubmit);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keyDownSubmit, false);
  }
}
</script>

<style>
/* dialog插入至body需要写样式修改背景色 */
.el-dialog__wrapper:has(.code-dialog) {
  background-color: transparent !important;
}
</style>

<style scoped>
.content-right {
  width: 444px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 9px 16px 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  box-sizing: border-box;
  padding-left: 49px;
  padding-top: 30px;
  position: relative;
}

.content-right .loginTypes {
  width: 100%;
  height: 20px;
  font-size: 14px;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 400;
  color: #03aaff;
  display: flex;
  align-items: center;
  margin: 22px 0 48px 0;
}

.loginTypes .loginType {
  margin-right: 57px;
  position: relative;
  cursor: pointer;
  color: #323232;
}

.loginTypes.loginType:last-child {
  margin-right: 0;
}

.loginTypes .loginType.active {
  color: #03aaff;
}

.loginTypes .loginType.active::after {
  content: "";
  position: absolute;
  width: 54px;
  height: 2px;
  background: #03aaff;
  left: 0;
  bottom: 0;
}

.content-right .title {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: rgba(50, 50, 50, 1);
  margin-bottom: 30px;
}

.content-right .forgetTitle {
  margin-bottom: 40px;
}

.tip {
  position: absolute;
  top: 85px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(197, 197, 197, 1);
}

::v-deep .el-form-item {
  margin-bottom: 24px;
}

.inputs {
  width: 337px;
  height: 45px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: #f7f4f8;
  border-radius: 20px;
  /* margin-bottom: 29px; */
  padding-left: 18px;
  position: relative;
}
.inputs + .inputs {
  margin-top: 20px;
}

.inputs .time-tips {
  position: absolute;
  bottom: -30px;
  color: #F56C6C;
  font-size: 14px;
}

.mobile {
  margin-left: 18px;
  width: 190px;
  height: 45px;
  display: flex;
  align-items: center;
  border: none;
  background: #f7f4f8;
  outline: none;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
}

.sms {
  margin-left: 18px;
  width: 185px;
  height: 45px;
  display: flex;
  align-items: center;
  border: none;
  background: #f7f4f8;
  outline: none;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
}

.login-code-img {
  width: inherit;
  width: 89px !important;
  height: 45px;
  border-radius: 0 10px 10px 0;
}

.send {
  width: 89px;
  height: 35px;
  background: rgba(255, 255, 255, 1);
  border-radius: 22px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(3, 170, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.inputs input::-webkit-input-placeholder {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(197, 197, 197, 1);
}

.inputs img {
  width: 17px;
}

.inputs::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 19px;
  background: rgba(197, 197, 197, 1);
  left: 42px;
}

.login {
  margin-top: 40px;
}

.login .el-button {
  width: 337px;
  height: 50px;
  background: linear-gradient(
    180deg,
    rgba(36, 173, 234, 1) 0%,
    rgba(18, 121, 219, 1) 100%
  );
  box-shadow: 0px 11px 11px 0px rgba(86, 169, 248, 0.34);
  border-radius: 28px !important;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.action {
  width: 280px;
  height: 50px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}

.action > div {
  width: 120px;
  height: 50px;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.cancel {
  background: rgba(192, 233, 255, 1);
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(47, 162, 231, 1);
}

.next {
  background: linear-gradient(
    180deg,
    rgba(36, 173, 234, 1) 0%,
    rgba(18, 121, 219, 1) 100%
  );
  box-shadow: 0px 11px 11px 0px rgba(86, 169, 248, 0.34);
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.forget {
  width: 337px;
  margin-top: 29px;
  font-size: 14px;
  cursor: pointer;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(137, 137, 137, 1);
  text-align: right;
  box-sizing: border-box;
  padding-right: 8px;
}

.wx_reg {
  width: 285px;
  height: 315px;
  margin-left: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.mb20 {
  margin-bottom: 25px !important;
}

/* 验证码弹窗样式 */
.smsCode-wrap {
  height: 160px;
}
.smsCode-title {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: rgb(150, 150, 150);
  margin-bottom: 16px;
}
.code-btn {
  width: 72px;
  height: 32px;
  padding: 0;
  margin: 0 10px 8px 0;
  border-radius: 18px !important;
  background: linear-gradient(180.00deg, rgb(36, 173, 234),rgb(18, 121, 219) 100%);
}
::v-deep .el-dialog {
  background: #fff;
  box-shadow: none;
}
::v-deep .el-dialog__header {
  padding: 20px 0 10px 28px;
}
::v-deep .el-dialog__title {
  display: inline-block;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 600;
  height: 20px;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}
::v-deep .el-dialog__body {
  padding: 0 0 0 28px;
}
</style>